module.exports = __webpack_public_path__ + "media/icons/heart-broken-3bde0e3636ff39ce195a1794dcd5b5bb.svg";